export type ClarityAdvisorImportHoldPhase = 'idle' | 'claiming' | 'extracting' | 'saving' | 'redirecting'

export const CLARITY_IMPORT_HOLD_STAGES = [
  'Linking your Clarity profile…',
  'Reading your bio and experience…',
  'Extracting account and skills details…',
  'Opening your advisor application…',
] as const

const PHASE_STAGE_INDEX: Record<Exclude<ClarityAdvisorImportHoldPhase, 'idle'>, number> = {
  claiming: 0,
  extracting: 1,
  saving: 2,
  redirecting: 3,
}

/** Last checklist row is reserved for the redirect so we never claim we are done early. */
export const HOLD_REVEAL_CAP = CLARITY_IMPORT_HOLD_STAGES.length - 2

export const holdStageIndexFromPhase = (phase: ClarityAdvisorImportHoldPhase): number => {
  if (phase === 'idle') {
    return -1
  }
  return PHASE_STAGE_INDEX[phase]
}

/**
 * Checklist cursor: real import phase is the floor; a timer may reveal later
 * rows so a slow claim still has something to read. Never the last row until redirect.
 */
export const holdActiveIndex = (phase: ClarityAdvisorImportHoldPhase, revealedIndex: number): number => {
  if (phase === 'idle') {
    return -1
  }
  if (phase === 'redirecting') {
    return PHASE_STAGE_INDEX.redirecting
  }
  const fromPhase = holdStageIndexFromPhase(phase)
  const fromTimer = Math.min(Math.max(0, revealedIndex), HOLD_REVEAL_CAP)
  return Math.max(fromPhase, fromTimer)
}
